export default "__VITE_ASSET__DbiPmcBu__"